import gql from "graphql-tag";

const getIndicadores = gql`
  query Query($idPlantilla: Int) {
    indicadores(idPlantilla: $idPlantilla) {
      id
      idPlantilla
      nivel
      formula
      descripcion
    }
  }
`;

const getCuentasProm = gql`
query Query($idEvaluacion3: Int!,$idEvaluacion2: Int!,$idEvaluacion1: Int!, $idCuenta: String!) {
  val1:
  detalleEvaluacionCuenta(idEvaluacion: $idEvaluacion1, idCuenta: $idCuenta) {
    idCuenta
    idEvaluacion
    valor
  }
  val2:
  detalleEvaluacionCuenta(idEvaluacion: $idEvaluacion2, idCuenta: $idCuenta) {
    idCuenta
    idEvaluacion
    valor
  }
  val3:
  detalleEvaluacionCuenta(idEvaluacion: $idEvaluacion3, idCuenta: $idCuenta) {
    idCuenta
    idEvaluacion
    valor
  }
}`;

const getVarTempProm = gql`
  query Query($idEvaluacion1: Int!,$idEvaluacion2: Int!,$idEvaluacion3: Int!, $idVarTemp: String!) {
    val1:
    detalleEvaluacionVarTemp(idEvaluacion: $idEvaluacion1, idVarTemp: $idVarTemp) {
      idEvaluacion
      idVarTemp
      valor
    }
    val2:
    detalleEvaluacionVarTemp(idEvaluacion: $idEvaluacion2, idVarTemp: $idVarTemp) {
      idEvaluacion
      idVarTemp
      valor
    }
    val3:
    detalleEvaluacionVarTemp(idEvaluacion: $idEvaluacion3, idVarTemp: $idVarTemp) {
      idEvaluacion
      idVarTemp
      valor
    }
  }
`;

const getVarProm = gql`
  query Query($idEvaluacion1: Int!,$idEvaluacion2: Int!,$idEvaluacion3: Int!, $idVariable: String!) {
    val1:
    detalleEvaluacionVariable(idEvaluacion: $idEvaluacion1, idVariable: $idVariable) {
      idEvaluacion
      idVariable
      valor
    }
    val2:
    detalleEvaluacionVariable(idEvaluacion: $idEvaluacion2, idVariable: $idVariable) {
      idEvaluacion
      idVariable
      valor
    }
    val3:
    detalleEvaluacionVariable(idEvaluacion: $idEvaluacion3, idVariable: $idVariable) {
      idEvaluacion
      idVariable
      valor
    }
  }
`;

const getInversion1 = gql`
  query Query($periodo: String!) {
    inversiones_sub_calculos(periodo: $periodo) {
      INV_01 {
        de_1_7
        de_16_30
        de_8_15
      }
    }
  }
`;

const getAsientos = gql`
query Query($periodo: String!) {
  creditos_sub_calculos(periodo: $periodo) {
    ASI_01 {
      de_1_7
      de_16_30
      de_8_15
    }
    ASI_02 {
      de_1_7
      de_16_30
      de_8_15
    }
  }
}
`;

const getLiquidez = gql`
  query Ahorros_sub_calculos($periodo: String!) {
    liquidaciones_sub_calculos(periodo: $periodo) {
      LIQ_01 {
        de_16_30
        de_1_7
        de_8_15
      },
      LIQ_02 {
        de_16_30
        de_1_7
        de_8_15
      }
    }
  }
`;

const getAhorros = gql`
  query Ahorros_sub_calculos($periodo: String!) {
    ahorros_sub_calculos(periodo: $periodo) {
      AHO_02 {
        de_16_30
        de_1_7
        de_8_15
      },
      AHO_03
      AHO_04
      AHO_05
    }
  }
`;

const getDetalleCuenta = gql`
  query Query($idEvaluacion: Int!, $idCuenta: String!) {
    detalleEvaluacionCuenta(idEvaluacion: $idEvaluacion, idCuenta: $idCuenta) {
      idCuenta
      idEvaluacion
      valor
    }
  }
`;

const getVarTemp = gql`
  query Query($idEvaluacion: Int!, $idVarTemp: String!) {
    detalleEvaluacionVarTemp(idEvaluacion: $idEvaluacion, idVarTemp: $idVarTemp) {
      idEvaluacion
      idVarTemp
      valor
    }
  }
`;

const getVariable = gql`
  query Query($idEvaluacion: Int!, $idVariable: String!) {
    detalleEvaluacionVariable(idEvaluacion: $idEvaluacion, idVariable: $idVariable) {
      idEvaluacion
      idVariable
      valor
    }
  }
`;

const getAnio = gql`
  query DetalleEvaluacionVarTemp($idVarTemp: String!, $idVarTemp2: String!, $idEvaluacion: Int!) {
    valor1:  
      detalleEvaluacionVarTemp(idVarTemp: $idVarTemp, idEvaluacion: $idEvaluacion) {
        idVarTemp
        valor
      }
    valor2:
      detalleEvaluacionVarTemp(idVarTemp: $idVarTemp2, idEvaluacion: $idEvaluacion) {
        idVarTemp
        valor
      }
  }
`;

const getVarTempDes = gql`
  query Query($varTempId: ID!,$varTempId2: ID!,$varTempId3: ID!, $idPlantilla: Int!) {
    valor1:
      varTemp(id: $varTempId, idPlantilla: $idPlantilla) {
        descripcion
        id
      }
    valor2:
      varTemp(id: $varTempId2, idPlantilla: $idPlantilla) {
        descripcion
        id
      }
    valor3:
      varTemp(id: $varTempId3, idPlantilla: $idPlantilla) {
        descripcion
        id
      }
  }
`;

export { getIndicadores, getCuentasProm, getVarTempProm, getVarProm, getInversion1, getAsientos, getLiquidez, getAhorros, getDetalleCuenta, getVarTemp, getVariable, getAnio, getVarTempDes };